import React, { useState, useEffect } from 'react';

// BRD Design Tokens
const T = {
  bg1:    '#0C1525',
  border: '#1E2D42',
  text:   '#E8EDF5',
  body:   '#B8C8DC',
  meta:   '#6A7D95',
  green:  '#00E896',
  cyan:   '#00C8FF',
  amber:  '#FFB340',
  red:    '#FF4466',
  blue:   '#4488FF',
};

const getTimeLeft = (targetHour, targetMinute) => {
  const now = new Date();
  const targetTime = new Date();
  targetTime.setHours(targetHour, targetMinute, 0, 0);
  if (targetTime <= now) targetTime.setDate(targetTime.getDate() + 1);
  const difference = targetTime - now;
  if (difference < 0) return { hours: 0, minutes: 0, seconds: 0, difference: 0 };
  return {
    hours:   Math.floor(difference / (1000 * 60 * 60)),
    minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((difference % (1000 * 60)) / 1000),
    difference,
  };
};

const ProfessionalCountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({ hours: 0, minutes: 0, seconds: 0, difference: 0 });
  const [phase, setPhase] = useState('pre-market');

  useEffect(() => {
    const updateTimer = () => {
      const now = new Date();
      const estTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
      const currentHour = estTime.getHours();
      const currentMinute = estTime.getMinutes();

      let targetHour = 9;
      let targetMinute = 30;
      let currentPhase = 'pre-market';

      if (currentHour > 9 || (currentHour === 9 && currentMinute >= 30)) {
        if (currentHour < 16) {
          targetHour = 16;
          targetMinute = 0;
          currentPhase = 'trading';
        } else {
          targetHour = 9;
          targetMinute = 30;
          currentPhase = 'after-hours';
        }
      }

      const newTimeLeft = getTimeLeft(targetHour, targetMinute);
      if (currentPhase === 'trading' && newTimeLeft.difference < 30 * 60 * 1000 && newTimeLeft.difference > 0) {
        currentPhase = 'closing-soon';
      }

      setTimeLeft(newTimeLeft);
      setPhase(currentPhase);
    };

    updateTimer();
    const timer = setInterval(updateTimer, 1000);
    return () => clearInterval(timer);
  }, []);

  const fmt = (n) => String(n).padStart(2, '0');

  const phaseConfig = {
    'trading':      { label: 'MARKET CLOSES IN', color: T.green,  eyebrow: 'LIVE SESSION' },
    'closing-soon': { label: 'CLOSING SOON',      color: T.amber,  eyebrow: 'CLOSING' },
    'after-hours':  { label: 'MARKET CLOSED',     color: T.meta,   eyebrow: 'AFTER HOURS' },
    'pre-market':   { label: 'MARKET OPENS IN',   color: T.blue,   eyebrow: 'PRE-MARKET' },
  };

  const { label, color, eyebrow } = phaseConfig[phase] || phaseConfig['pre-market'];

  const segmentStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: '24px',
  };

  const digitStyle = {
    fontFamily: "'DM Mono', monospace",
    fontSize: '16px',
    fontWeight: 600,
    color,
    lineHeight: 1,
    letterSpacing: '-0.02em',
    fontVariantNumeric: 'tabular-nums',
  };

  const unitStyle = {
    fontFamily: "'DM Mono', monospace",
    fontSize: '7px',
    fontWeight: 500,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: T.meta,
    marginTop: '2px',
  };

  const separatorStyle = {
    fontFamily: "'DM Mono', monospace",
    fontSize: '13px',
    fontWeight: 300,
    color,
    opacity: 0.4,
    margin: '0 2px',
    paddingBottom: '8px',
    lineHeight: 1,
  };

  return (
    <div style={{
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '6px 14px 8px',
      backgroundColor: color + '12',
      border: `1px solid ${color}30`,
      borderRadius: '6px',
      minWidth: '160px',
    }}>

      {/* Eyebrow */}
      <div style={{
        fontFamily: "'DM Mono', monospace",
        fontSize: '9px',
        fontWeight: 500,
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        color: T.meta,
        marginBottom: '2px',
      }}>
        {eyebrow}
      </div>

      {/* Phase label */}
      <div style={{
        fontFamily: "'DM Mono', monospace",
        fontSize: '9px',
        fontWeight: 500,
        letterSpacing: '0.08em',
        color,
        marginBottom: '8px',
      }}>
        {label}
      </div>

      {/* Time digits */}
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div style={segmentStyle}>
          <span style={digitStyle}>{fmt(timeLeft.hours)}</span>
          <span style={unitStyle}>hrs</span>
        </div>

        <span style={separatorStyle}>:</span>

        <div style={segmentStyle}>
          <span style={digitStyle}>{fmt(timeLeft.minutes)}</span>
          <span style={unitStyle}>min</span>
        </div>

        <span style={separatorStyle}>:</span>

        <div style={segmentStyle}>
          <span style={digitStyle}>{fmt(timeLeft.seconds)}</span>
          <span style={unitStyle}>sec</span>
        </div>
      </div>

    </div>
  );
};

export default ProfessionalCountdownTimer;